export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const USER_LOGGEDIN = 'USER_LOGGEDIN'
export const RESPONSE_DATA = 'RESPONSE_DATA'